module.exports = __webpack_public_path__ + "static/media/google.871ae01b.svg";